import _ from "lodash";
import { CurtailmentObjectType } from "../../requests_cm/gecoSitesService/types";
import { CurtailmentObjectGroupType } from "../../features/contract_period/ContractPeriodTabs/CurtailmentObjectTab/CurtailmentObject.types";
import { useEffect, useMemo, useState } from "react";

export interface CurtailmentObjcetsFilters {
	curtailementObjectsGroupsBySites: CurtailmentObjectGroupType[];
	updateFilterByKinds: (kinds: { name: string; isActive: boolean }[]) => void;
	filterByKinds: { name: string; isActive: boolean }[];
}

export const useCurtailementObjectsFilters = (
	curtailmentObjects: CurtailmentObjectType[] | undefined
): CurtailmentObjcetsFilters => {
	const [activeCurtailementKinds, setActiveCurtailementKinds] = useState<
		{ name: string; isActive: boolean }[]
	>([]);

	useEffect(() => {
		if (curtailmentObjects?.length) {
			const data = _.uniqBy(
				curtailmentObjects.map((curtailement) => ({
					name: curtailement.curtailment_kind,
					isActive: true,
				})),
				"name"
			);
			setActiveCurtailementKinds(data);
		}
	}, [curtailmentObjects]);

	const curtailementObjectsGroupsBySites = useMemo(() => {
		if (curtailmentObjects) {
			const activeKinds = _.filter(activeCurtailementKinds, {
				isActive: true
			}).map(kind => kind.name)
			return _.values(_.groupBy(curtailmentObjects, "site.name")).map(
				(groupedCurtailementBySite) => {
					const site = groupedCurtailementBySite[0].site
					const activeCurtailements = groupedCurtailementBySite.filter((curtailement) => activeKinds.includes(curtailement.curtailment_kind))
					const activeKindsOnSite = [...new Set(activeCurtailements.map(curtailement => curtailement.curtailment_kind))];
					return {
						site,
						data: activeCurtailements,
						curtailmentKinds: activeKindsOnSite
					}
				}
			);
		}
		return [];
	}, [curtailmentObjects, activeCurtailementKinds]);

	return {
		curtailementObjectsGroupsBySites,
		updateFilterByKinds: setActiveCurtailementKinds,
		filterByKinds: activeCurtailementKinds,
	};
};
